export const INTERNAL_ROLE = 'internal_employee';
export const INTERNAL_LABEL = 'Salarié interne / Dispatcher';
export const canManageInternal = (user) => user?.role === 'admin' && (
  user.is_super_admin === true || user.email === 'transport@dlv-express.com' || user.admin_level === 'full'
);
export const parisDate = (value = new Date()) => new Intl.DateTimeFormat('fr-CA', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
}).format(value);
export const initialPeriod = () => {
  const now = new Date();
  return { start: `${parisDate(now).slice(0, 7)}-01`, end: parisDate(new Date(now.getFullYear(), now.getMonth() + 1, 0, 12)) };
};
export const currentMonth = () => parisDate().slice(0, 7);
export const monthPeriod = (month) => {
  const [year, index] = month.split('-').map(Number);
  return { start: `${month}-01`, end: parisDate(new Date(year, index, 0, 12)) };
};
export const shiftMonth = (month, delta) => {
  const [year, index] = month.split('-').map(Number);
  return parisDate(new Date(year, index - 1 + delta, 1, 12)).slice(0, 7);
};
const parisOffsetMinutes = (date) => {
  const part = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', timeZoneName: 'longOffset' }).formatToParts(date).find(p => p.type === 'timeZoneName')?.value || '';
  const match = part.match(/([+-])(\d{2}):(\d{2})/);
  return match ? (match[1] === '-' ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3])) : 0;
};
export const parisLocalToIso = (local) => {
  const guess = new Date(`${local}:00Z`);
  return new Date(guess.getTime() - parisOffsetMinutes(guess) * 60000).toISOString();
};
export const isoToParisLocal = (value) => value ? new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
}).format(new Date(value)).replace(' ', 'T') : '';
export const secondsLabel = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds || 0)));
  return `${Math.floor(total / 3600)} h ${Math.floor((total % 3600) / 60)} min ${total % 60} s`;
};
export const entrySeconds = (entry) => entry.worked_seconds ?? Math.round((entry.worked_minutes || 0) * 60);
export const displayTime = (value) => value ? new Date(value).toLocaleString('fr-FR', {
  timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
}) : 'En cours';
export const apiError = (error) => typeof error.response?.data?.detail === 'string'
  ? error.response.data.detail : 'Enregistrement impossible. Vérifiez les champs et réessayez.';